// Npm
import React, { FC, memo, ReactElement, useEffect } from 'react';

// Local
import { useApAsyncDispatch, useAppDispatch, useAppSelector } from '../../app/hooks';
import Dashboard from '../../components/Dashboard';
import {
  fetchReferenceAddressData,
  fetchUltimateParentData,
  fetchUserDetails,
  selectUserDetails,
  setUserLoggedOut
} from '../../pages/Home/HomeSlice';
import { resetLegalEntity } from '../../pages/LegalEntity/LegalEntitySlice';
import { last, ORIGIN_MAPPING, triggerAnalytics } from '../../utils/helper';
import { fetchEncryptionKey, resetCreate } from './../../pages/Create/CreateSlice';
import './Home.css';

interface Props {}

/**
 * @param {*} {}
 * @return {ReactElement}
 */
const Home: FC<Props> = (): ReactElement => {
  const storeDispatch = useAppDispatch();
  const storeAsyncDispatch = useApAsyncDispatch();
  const { personaId, sponsorCode, address, ultimateParent } = useAppSelector(selectUserDetails);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://js-cdn.dynatrace.com/jstag/${ORIGIN_MAPPING[last].dynatraceId}_complete.js`;
    script.crossOrigin = 'anonymous';

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const getUserData = () => {
      storeAsyncDispatch(fetchUserDetails());
      storeDispatch(setUserLoggedOut(false));
      storeAsyncDispatch(fetchEncryptionKey());
    };
    storeDispatch(resetLegalEntity());
    storeDispatch(resetCreate());
    if (typeof personaId !== 'number') {
      getUserData();
    }
  }, []);

  useEffect(() => {
    if (typeof personaId === 'number') {
      if (address === undefined || address?.length === 0) {
        storeAsyncDispatch(fetchReferenceAddressData(sponsorCode as string));
      }
      if (ultimateParent === undefined) {
        storeAsyncDispatch(fetchUltimateParentData(sponsorCode as string));
      }
    }
  }, [sponsorCode, personaId]);

  useEffect(() => {
    if (typeof personaId === 'number') {
      triggerAnalytics(
        {
          pageName: 'Dashboard',
          pageRoute: '/home'
        },
        personaId,
        sponsorCode as string
      );
    }
  }, [personaId, sponsorCode]);

  return <Dashboard />;
};

Home.displayName = 'Home';
export default memo(Home);
